import React from 'react';
class BgAudio extends React.Component {
    render() {
        return (
            <audio loop={true} autoPlay={true} controls={"controls"} style={{ height: 0 }}>
                <source src={require("../../assets/audio/bg_audio.mp3")} />
                <source src={require("../../assets/audio/bg_audio.wav")} />
            </audio>
        )
    }


}
export default BgAudio;